import { expValEquals } from '@confluence/feature-experiments';

import type { Participant } from '../presenceTypes';
import { MAX_GROUP_SIZE } from '../presenceUtils';

export const useIsEligibleForSuggestions = (
	participants: Participant[],
	isLoggedIn: boolean,
	isGuest: boolean,
	isExternalShareRequest: boolean,
) => {
	// Check if the user is eligible for suggestions based on their login status, guest status, the number of participants, and if link is external.
	if (!isLoggedIn || isGuest || participants.length >= MAX_GROUP_SIZE || isExternalShareRequest) {
		return false;
	}

	if (expValEquals('collab_in_team_presence_exp', 'cohort', 'variation')) {
		return true;
	}
	return false;
};
